// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"29b8d740","81":"c8ff4d9d","219":"1215c934","336":"a0e993ae","496":"e9a43956","513":"bd256d0b","937":"f2ea0b83","986":"c67346d4"}[chunkId] + ".chunk.js";
};